import Layout from '../../components/Layout';
import Hero from './Hero/Hero';
import * as styles from './downloadApp.module.css';
import WhatsNew from './WhatsNew/WhatsNew';

const DownloadApp = () => (
  <Layout pageTitle="Download the App">
    <div className={styles.container}>
      <Hero />
      <WhatsNew />
    </div>
  </Layout>
);

export default DownloadApp;
